import { Flame, CheckCircle2, TrendingUp, BellRing } from 'lucide-react';
import { Card } from '@/components/ui/card';

interface ProgressSummaryCardsProps {
  streakDays: number;
  weeklyCompleted: number;
  weeklyTarget: number;
  totalCompletedDays: number;
  programTargetDays: number;
  activeAlerts: number;
}

export const ProgressSummaryCards = ({
  streakDays,
  weeklyCompleted,
  weeklyTarget = 7,
  totalCompletedDays,
  programTargetDays = 21,
  activeAlerts,
}: ProgressSummaryCardsProps) => {
  return (
    <div className="grid grid-cols-2 gap-4">
      {/* Streak */}
      <Card className="p-4 bg-white shadow-sm border-slate-100 rounded-3xl flex flex-col gap-2">
        <div className="bg-orange-50 w-10 h-10 rounded-2xl flex items-center justify-center text-orange-500">
          <Flame className="h-5 w-5" />
        </div>
        <div>
          <p className="text-2xl font-bold text-slate-900 leading-none">{streakDays}</p>
          <p className="text-xs text-slate-500 mt-1">Días seguidos</p>
        </div>
      </Card>

      {/* Weekly */}
      <Card className="p-4 bg-white shadow-sm border-slate-100 rounded-3xl flex flex-col gap-2">
        <div className="bg-green-50 w-10 h-10 rounded-2xl flex items-center justify-center text-green-600">
          <CheckCircle2 className="h-5 w-5" />
        </div>
        <div>
          <p className="text-2xl font-bold text-slate-900 leading-none">
            {weeklyCompleted}<span className="text-sm text-slate-400 ml-0.5">/{weeklyTarget}</span>
          </p>
          <p className="text-xs text-slate-500 mt-1">Esta semana</p>
        </div>
      </Card>

      {/* Protocol */}
      <Card className="p-4 bg-white shadow-sm border-slate-100 rounded-3xl flex flex-col gap-2">
        <div className="bg-blue-50 w-10 h-10 rounded-2xl flex items-center justify-center text-blue-600">
          <TrendingUp className="h-5 w-5" />
        </div>
        <div>
          <p className="text-2xl font-bold text-slate-900 leading-none">
            {totalCompletedDays}<span className="text-sm text-slate-400 ml-0.5">/{programTargetDays}</span>
          </p>
          <p className="text-xs text-slate-500 mt-1">Días completados</p>
        </div>
      </Card>

      {/* Alerts */}
      <Card className="p-4 bg-white shadow-sm border-slate-100 rounded-3xl flex flex-col gap-2">
        <div className="bg-purple-50 w-10 h-10 rounded-2xl flex items-center justify-center text-purple-600">
          <BellRing className="h-5 w-5" />
        </div>
        <div>
          <p className="text-2xl font-bold text-slate-900 leading-none">{activeAlerts}</p>
          <p className="text-xs text-slate-500 mt-1">Alertas activas</p>
        </div>
      </Card>
    </div>
  );
};
